export default "__VITE_ASSET__BfQFDBYG__"